import { useQuery } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'

import { shipperFetch } from '@/utils/shipperFetch'

export const quoteRequestKeys = {
  all: ['quote-request'] as const,
  request: (id?: string) => [...quoteRequestKeys.all, id ?? null] as const,
}

const fetchQuoteRequestShipments = (quoteRequestId?: string) => async () => {
  if (!quoteRequestId) {
    throw new Error('fetchQuoteRequestShipments called without quoteRequestId')
  }
  return shipperFetch<FullShipment[]>(
    `/shipments/by-quote-request/${quoteRequestId}`,
  )
}

export function useQuoteRequest(id?: string, enabled = true) {
  const query = useQuery(
    quoteRequestKeys.request(id),
    fetchQuoteRequestShipments(id),
    {
      enabled: !!id && enabled,
    },
  )
  return query
}
